import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Text } from "@cinch-labs/design-system";
import { TrustpilotOverview } from "@cinch-nx/landing-ui-shared";
import { TrackingEventTypes, useAnalytics } from "@cinch-nx/shared-analytics";
import cx from "classnames";
import Image from "next/image";
import homePageLocales from "../../locale";
import { Filters } from "./filters";
import styles from "./hero.module.css";
var HomeHero = function(param) {
    var image = param.image, heading = param.heading, makes = param.makes, totalStock = param.totalStock, starRating = param.starRating, starRatingLabel = param.starRatingLabel, introFirstLine = param.introFirstLine;
    var helpMeChoose = homePageLocales.hero.helpMeChoose;
    var trackEvent = useAnalytics().trackEvent;
    var sendHmcTrackEvent = function() {
        trackEvent({
            eventName: "Help me choose hero link",
            type: TrackingEventTypes.ADOBE,
            data: {
                event: {
                    name: "click",
                    category: "link",
                    label: "Help me choose hero link",
                    action: "Help me choose hero link link click"
                }
            }
        });
    };
    var sendShopCarsOnOfferTrackEvent = function() {
        trackEvent({
            eventName: "shop cars on offer",
            type: TrackingEventTypes.ADOBE,
            data: {
                event: {
                    name: "click",
                    category: "promotions",
                    label: "winter sale 2024",
                    action: "hero"
                }
            }
        });
    };
    var introFirstLineTextToReplace = "Get \xa3250 - \xa31000 off selected cars, all with a 14-day money back guarantee";
    var IntroFirstLineReplacement = function() {
        return /*#__PURE__*/ _jsxs(Text, {
            className: styles["intro"],
            element: "h2",
            children: [
                "Get \xa3250 - \xa31000 off selected cars, all with a 14-day money back guarantee.",
                " ",
                /*#__PURE__*/ _jsx("a", {
                    href: "/used-cars?tags=cars-on-offer",
                    className: styles["hero-link"],
                    onClick: function() {
                        return sendShopCarsOnOfferTrackEvent();
                    },
                    children: "Shop cars on offer"
                }),
                "."
            ]
        });
    };
    var _alt;
    return /*#__PURE__*/ _jsxs("section", {
        className: styles["container"],
        "aria-describedby": "hero-heading",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: cx(styles["background"], styles["backgroundGradient"])
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: styles["inner"],
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: styles["textContainer"],
                        children: [
                            /*#__PURE__*/ _jsx(Text, {
                                className: styles["heading"],
                                element: "h1",
                                "data-testid": "hero-title",
                                children: heading
                            }),
                            introFirstLine === introFirstLineTextToReplace ? /*#__PURE__*/ _jsx(IntroFirstLineReplacement, {}) : /*#__PURE__*/ _jsx(Text, {
                                className: styles["intro"],
                                element: "h2",
                                children: introFirstLine
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: styles["flexDirection"],
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: styles["imageContainer"],
                                children: /*#__PURE__*/ _jsx(Image, {
                                    src: image.filename,
                                    alt: (_alt = image.alt) !== null && _alt !== void 0 ? _alt : "",
                                    layout: "fill",
                                    className: styles["heroImage"],
                                    priority: true
                                })
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: styles["filtersHmcContainer"],
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: styles["filtersHmcInner"],
                                    children: [
                                        /*#__PURE__*/ _jsx(Filters, {
                                            makes: makes,
                                            totalStock: totalStock
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: styles["hmcContainer"],
                                            children: /*#__PURE__*/ _jsxs(Text, {
                                                className: styles["hmcText"],
                                                children: [
                                                    /*#__PURE__*/ _jsx("span", {
                                                        children: helpMeChoose.mobile.paragraph1
                                                    }),
                                                    /*#__PURE__*/ _jsxs("span", {
                                                        children: [
                                                            helpMeChoose.mobile.paragraph2,
                                                            /*#__PURE__*/ _jsx("a", {
                                                                href: "/help-me-choose/most-important",
                                                                className: styles["hmcLink"],
                                                                onClick: function() {
                                                                    return sendHmcTrackEvent();
                                                                },
                                                                children: helpMeChoose.mobile.link
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(TrustpilotOverview, {
                starRating: starRating,
                starRatingLabel: starRatingLabel
            })
        ]
    });
};
export default HomeHero;
